// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable */
.Checkbox_container__h-BJC {
  display: flex;
  gap: 10px;
  position: relative;
  color: var(--font-primary-color);
}

.Checkbox_field__W4fhU {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
}

input[type=checkbox] {
  outline: 0;
  opacity: 0;
  margin: 0;
  margin-left: 5px;
  display: block;
  float: left;
  font-size: inherit;
}
input[type=checkbox][data-indeterminate=true] + .Checkbox_label__FjP5Y::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 4px;
  transform: rotate(90deg);
  width: 0.7em;
  height: 0.7em;
  border-radius: 50%;
  background: var(--accent-color);
}
input[type=checkbox]:checked {
  outline: 0;
  opacity: 0;
  display: block;
  float: left;
  font-size: inherit;
}
input[type=checkbox]:checked + .Checkbox_label__FjP5Y::after {
  content: "";
  position: absolute;
  left: 0;
  transform: translate(0.25em, 0.4em) rotate(-45deg);
  width: 0.75em;
  height: 0.375em;
  border: 2px solid var(--accent-color);
  border-top-style: none;
  border-right-style: none;
  top: -1px;
}

.Checkbox_label__FjP5Y {
  width: 100%;
}
.Checkbox_label__FjP5Y::before {
  content: "";
  position: absolute;
  left: 0;
  width: 18px;
  height: 18px;
  background: white;
  border: 1px solid var(--font-primary-color);
  border-radius: 3px;
  cursor: pointer;
  transition: background 0.3s;
  top: -1px;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Checkbox/Checkbox.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAAA,sBAAA;AAIA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,gCCLa;ADGf;;AAKA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,aEbU;AFWZ;;AAKA;EACE,UAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAFF;AAMM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,+BCvCC;ADmCT;AASE;EACE,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAPJ;AAUM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,kDAAA;EACA,aAAA;EACA,eAAA;EACA,qCAAA;EACA,sBAAA;EACA,wBAAA;EACA,SAAA;AARR;;AAcA;EACE,WAAA;AAXF;AAaE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBE/EY;EFgFZ,eAAA;EACA,2BAAA;EACA,SAAA;AAXJ","sourcesContent":["/* stylelint-disable */\n@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n\n.container {\n  display: flex;\n  gap: 10px;\n  position: relative;\n  color: $font-primary;\n}\n\n.field {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: $padding-m;\n}\n\ninput[type='checkbox'] {\n  outline: 0;\n  opacity: 0;\n  margin: 0;\n  margin-left: 5px;\n  display: block;\n  float: left;\n  font-size: inherit;\n\n  &[data-indeterminate='true'] {\n    + .label {\n      &::after {\n        content: '';\n        position: absolute;\n        left: 4px;\n        top: 4px;\n        transform: rotate(90deg);\n        width: 0.7em;\n        height: 0.7em;\n        border-radius: 50%;\n        background: $accent;\n      }\n    }\n  }\n\n  &:checked {\n    outline: 0;\n    opacity: 0;\n    display: block;\n    float: left;\n    font-size: inherit;\n\n    + .label {\n      &::after {\n        content: '';\n        position: absolute;\n        left: 0;\n        transform: translate(0.25em, 0.4em) rotate(-45deg);\n        width: 0.75em;\n        height: 0.375em;\n        border: 2px solid $accent;\n        border-top-style: none;\n        border-right-style: none;\n        top: -1px;\n      }\n    }\n  }\n}\n\n.label {\n  width: 100%;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    width: 18px;\n    height: 18px;\n    background: white;\n    border: 1px solid $font-primary;\n    border-radius: $border-radius;\n    cursor: pointer;\n    transition: background 0.3s;\n    top: -1px;\n  }\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Checkbox_container__h-BJC`,
	"field": `Checkbox_field__W4fhU`,
	"label": `Checkbox_label__FjP5Y`
};
export default ___CSS_LOADER_EXPORT___;
